import { appstr } from "./appstr";
import { Globals } from "../CoreApp/Globals";

export function loadingphotos() {
  var w = Globals._wsMgr;
  var dMgr = w.GetDocMgr();
  var theDoc = dMgr.GetCurrentDoc();
  var loadCount = theDoc.GetPicLoadCount();
  if (loadCount > 0) {
    var m = appstr("photoqueue") + " (" + loadCount.toString() + ")";
    w.DoProgress(m);
    setTimeout(function () {
      loadingphotos();
    }, 50);
  } else {
    w.EndProgress();
    w.PhotosLoaded();
  }
}
